import type { PDFDocument, PDFFont } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

/** Embed the e-Ukraine font family (Latin + Cyrillic) into a pdf-lib document.
 *  Both fonts are subsetted so they only carry the glyphs actually used. */
export async function embedEUkraineFonts(
  pdf: PDFDocument,
): Promise<{ regular: PDFFont; bold: PDFFont }> {
  pdf.registerFontkit(fontkit);
  const [regularBytes, boldBytes] = await Promise.all([
    fetch("/fonts/e-Ukraine-Regular.otf").then((r) => r.arrayBuffer()),
    fetch("/fonts/e-Ukraine-Bold.otf").then((r) => r.arrayBuffer()),
  ]);
  const [regular, bold] = await Promise.all([
    pdf.embedFont(regularBytes, { subset: true }),
    pdf.embedFont(boldBytes, { subset: true }),
  ]);
  return { regular, bold };
}

/** Trim text with an ellipsis to fit within `maxW` at the given font/size. */
export function truncateToWidth(
  font: PDFFont,
  text: string,
  size: number,
  maxW: number,
): string {
  if (font.widthOfTextAtSize(text, size) <= maxW) return text;
  let lo = 0;
  let hi = text.length;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (font.widthOfTextAtSize(text.slice(0, mid) + "…", size) <= maxW) {
      lo = mid;
    } else {
      hi = mid - 1;
    }
  }
  return text.slice(0, lo) + "…";
}
